import { useState } from "react";
import { Link } from "react-router-dom";
import { BRAND } from "@/lib/content";

// Brand lockup using the real Danny Clans logo image with a text fallback
// if the image ever fails to load (network issue, image-blocking extensions,
// corporate proxy stripping cross-origin images, etc.).
// `size` controls overall height (sm | md | lg).

// Size-driven presentation tokens. Extracted to avoid nested ternaries
// and make future size additions trivial.
const SIZE_TOKENS = {
  sm: { heightClass: "h-[72px]", pxHeight: 72,  textClass: "text-lg" },
  md: { heightClass: "h-24",     pxHeight: 96,  textClass: "text-2xl" },
  lg: { heightClass: "h-[120px]",pxHeight: 120, textClass: "text-3xl" },
};

// Native logo aspect ratio (1080 × 520). We compute a matching pixel width
// so browsers reserve exact layout space and avoid CLS.
const LOGO_ASPECT = 1080 / 520;

export const LogoLockup = ({ size = "md", className = "" }) => {
  const { heightClass, pxHeight, textClass } = SIZE_TOKENS[size] || SIZE_TOKENS.md;
  const pxWidth = Math.round(pxHeight * LOGO_ASPECT);
  const [imgFailed, setImgFailed] = useState(false);

  return (
    <Link to="/" className={`flex items-center ${className}`} data-testid="nav-logo-link">
      {imgFailed ? (
        <span className={`font-extrabold tracking-tight text-slate-900 ${textClass}`}>
          {BRAND.name}
        </span>
      ) : (
        <picture>
          <source srcSet={BRAND.logoUrl} type="image/webp" />
          <img
            src={BRAND.logoUrlFallback || BRAND.logoUrl}
            alt={`${BRAND.name} logo — ${BRAND.tagline}`}
            width={pxWidth}
            height={pxHeight}
            fetchPriority="high"
            decoding="async"
            className={`${heightClass} w-auto select-none`}
            draggable="false"
            onError={() => setImgFailed(true)}
            data-testid="nav-logo-img"
          />
        </picture>
      )}
    </Link>
  );
};
